// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2iCGx","choiceBoxes":"toolbarselects_choiceBoxes__1XRpo","simpleField":"toolbarselects_simpleField__3CGYH"};